import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UploadedFilesContextValue {
  files: File[];
  password: string;
  setFiles: (files: File[]) => void;
  setPassword: (pw: string) => void;
  clear: () => void;
}

const UploadedFilesContext = createContext<UploadedFilesContextValue | null>(null);

export function UploadedFilesProvider({ children }: { children: ReactNode }) {
  const [files, setFiles] = useState<File[]>([]);
  const [password, setPassword] = useState<string>('4634');
  return (
    <UploadedFilesContext.Provider value={{ files, password, setFiles, setPassword, clear: () => setFiles([]) }}>
      {children}
    </UploadedFilesContext.Provider>
  );
}

export function useUploadedFiles(): UploadedFilesContextValue {
  const ctx = useContext(UploadedFilesContext);
  if (!ctx) throw new Error('useUploadedFiles must be used within UploadedFilesProvider');
  return ctx;
}
